import { render } from "./ConfigurationPrice.vue?vue&type=template&id=03dbae1e"
import script from "./ConfigurationPrice.vue?vue&type=script&lang=js"
export * from "./ConfigurationPrice.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ConfigurationPrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03dbae1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03dbae1e', __exports__)) {
    console.log('reload')
    api.reload('03dbae1e', __exports__)
  }
  
  module.hot.accept("./ConfigurationPrice.vue?vue&type=template&id=03dbae1e", () => {
    console.log('re-render')
    api.rerender('03dbae1e', render)
  })

}


export default __exports__